module.exports = __webpack_public_path__ + "img/1.218ea2e7.jpeg";